import React, { FC, ReactNode } from 'react';

export interface ButtonGroupProps {
    children: ReactNode;
}

export const ButtonGroup: FC<ButtonGroupProps> = ({ children }) => {
    return (
        <div className="btn-group" role="group">
            {children}
        </div>
    );
};
